module.exports = __webpack_public_path__ + "media/images/logo-b1a2214a020107fc77fdc909d6c9cc9b.svg";